export const AI_DISCLOSURE_VOICE_MESSAGE_ERROR_PREFIX = "Edit the First Message to identify AI before enabling disclosure: "

/** Expected disclosure failures whose messages are safe to return to the operator. */
export class AiDisclosureSettingError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "AiDisclosureSettingError"
  }
}
